import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import withOrganization from 'App/Decorators/withOrganization'
import AddProducts from './AddProducts'
import MdInfoOutline from 'react-icons/lib/md/info-outline'

@withOrganization
export default class Add extends React.Component {
  static propTypes = {
    organization: PropTypes.object
  }

  render() {
    const organization = this.props.organization
    if (organization.slug !== 'securitysat') return
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <div className="row">
              <div className="col-xs-12 col-sm-6">
                <h3 className={styles.title}>Como agregar productos a la base de datos</h3>
              </div>
              <div className="col-xs-12 col-sm-6 end-md">
                <div className={styles.icon}>
                  <MdInfoOutline />
                </div>
              </div>
            </div>
          </div>
          <div className="content">
            <div className={styles.text}>
              <p>
                Para agregar productos de Security Sat a la base de datos, se debe generar un
                archivo <b>.csv</b> de datos, con la siguiente estructura:
              </p>
            </div>
            <div className={styles.csv}>
              <img className={styles.image} src="/csv.png" alt="productos" />
            </div>
            <p>
              La primera linea del archivo debe tener la cabecera de los datos. El código del
              producto, el nombre y el precio. Esta estructura es <b>obligatoria</b>.{' '}
            </p>
            <p>
              Luego, se agregan los datos de los producto haciendo salto de linea por cada conjunto
              de datos. En el caso del precio solo se debe ingresar el número, sin caracteres
              especiales como '$' y sin comas.
            </p>
            <p>
              Una vez que el archivo <b>.csv</b> contenga los datos necesarios, se procede al boton
              "<b>Cargar Productos</b>" en la sección de abajo. Se abrirá una ventana con los
              archivos del ordenador del usuario. Se selecciona el archivo <b>.csv</b> y se carga.
              Al momento de que el archivo se haya subido correctamente, aparecerá una tabla
              indicando cuales son los datos extraidos del archivo. Luego de esto, se procede a
              apretar el boton "<b>Guardar Productos</b>".
            </p>
          </div>
        </div>
        <AddProducts />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Custom/Add/index.js